// Colours, font and shadows copied from the Lovable mock's Tailwind theme
// (lovable/screenhub-cms/src/index.css) so the pop-up matches it exactly.
export const color = {
  background: 'hsl(210, 20%, 98%)',
  foreground: 'hsl(222, 47%, 11%)',
  muted40: 'hsla(210, 40%, 96%, 0.4)',
  mutedForeground: 'hsl(215, 16%, 47%)',
  accent: 'hsl(210, 40%, 96%)',
  border: 'hsl(214, 32%, 91%)',
  primary: 'hsl(199, 89%, 48%)',
  primary90: 'hsla(199, 89%, 48%, 0.9)',
  primary10: 'hsla(199, 89%, 48%, 0.1)',
  primary5: 'hsla(199, 89%, 48%, 0.05)',
  warning: 'hsl(38, 92%, 50%)',
  warning15: 'hsla(38, 92%, 50%, 0.15)',
  destructive: 'hsl(0, 84%, 60%)',
  destructive15: 'hsla(0, 84%, 60%, 0.15)',
  success: 'hsl(142, 71%, 45%)',
  success10: 'hsla(142, 71%, 45%, 0.1)',
  white: '#FFFFFF'
}

// Stripe's iframes want plain colours; these are the hex forms of foreground / muted-foreground.
export const stripeColor = {
  foreground: '#0F172A',
  mutedForeground: '#64748B',
  destructive: '#EF4444'
}

export const fontFamily = 'Inter, system-ui, sans-serif'

// Tailwind `shadow-lg` and the `focus-visible:ring-2 ring-offset-2` focus ring.
export const shadowLg = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)'
export const focusRing = `0 0 0 2px ${color.background}, 0 0 0 4px ${color.primary}`

// Tailwind's `sm` and `md` breakpoints (not Material-UI's, which differ).
export const smUp = '@media (min-width: 640px)'
export const mdUp = '@media (min-width: 768px)'
